import { Button } from "@chakra-ui/button";
import { Box, Center, Heading } from "@chakra-ui/layout";
import { useBreakpointValue } from "@chakra-ui/media-query";
import Link from "next/link";

const Tracking = () => {
  const mobile = useBreakpointValue({ base: true, md: false });
  return (
    <Box bgGradient="linear(to-b, jet, #101010)" h="100vh" px={mobile && 4}>
      <Center
        w={mobile ? "100%" : "1088px"}
        mx="auto"
        h="100%"
        flexDir="column"
      >
        <Heading variant="h1" textAlign="center">
          This page is currently under construction. Please check back again
          later!
        </Heading>
        <Button fontWeight="regular" fontSize="36px" mt="60px">
          <Link href="/">
            <a>Back to Home</a>
          </Link>
        </Button>
      </Center>
    </Box>
  );
};

export default Tracking;
